import styled from 'styled-components';

export const FieldValidationCellStyled = styled.div`
  display: flex;
  gap: 8px;

  align-items: center;
  justify-content: space-between;

  .form-group {
    margin-bottom: 0;

    & > div {
      padding: 0;
    }
  }
`;
